import { Component } from 'react';
import { connect } from 'react-redux';
import api from 'api';
import { FeedbackContainer } from 'components/common/feedback';

export default connect((state) => state)(
  class extends Component {
    state = {
      courses: null
    };

    componentDidMount() {
      this.getCourses();
    }

    getCourses = async () => {
      const {
        dispatch,
        pageState: { user }
      } = this.props;

      try {
        const courses = await api.get(
          `/admin/users/${user.id}/participated-courses`
        );
        this.setState({
          courses: courses.data.courses
        });
      } catch (err) {
        this.setState({ loading: false });
        await dispatch.handleErrorDispatch(err);
      }
    };

    render() {
      const {
        isUserPage,
        messages,
        pageState: { user }
      } = this.props;
      const { courses } = this.state;

      return (
        <div className="summary">
          <FeedbackContainer
            courses={courses}
            emptyDescription={
              isUserPage
                ? messages.profileFeedbacksEmptyDescription
                : messages.profileFeedbacksEmptyDescriptionSelf
            }
            userId={user ? user.id : null}
            showCourse={true}
            titleText={messages.profileFeedbacks}
          />
        </div>
      );
    }
  }
);
